// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3uL9P","colCheckbox":"styles_colCheckbox__3m4GL"};